import { buildUri, includeCSSFilePromise } from "../utils/dom";

export class SchedulerContainerComponent extends HTMLElement {

    get header() {
        return this.querySelector(".modal-header");
    }

    get logoContainer() {
        return this.header.querySelector(".client-logo-container");
    }

    get #content() {
        return this.querySelector("main.panel-body");
    }

    constructor() {
        super();
        this.container = this.attachShadow({ mode: "open" });
        this.container.innerHTML = `
        <div id="v24SchedulerContent" class="v24Scheduler"></div>
        `;
        this.#propagateRtlDirection();
        this.#observeHtmlDirAttribute();
    }

    showModal(val) {
        const contentDiv = this.container.querySelector("#v24SchedulerContent");
        if (!contentDiv) {
            return;
        }

        if (val) {
            contentDiv.innerHTML = `
                <div id="v24SchedulerModal" class="v24-scheduler-modal v24-show-flex">
                    <!-- Modal content -->
                    <div class="v24-scheduler-modal-dialog" role="document">
                        <section alt="v24-scheduler-modal-content" class="modal-content">
                            <div class="modal-header">
                                <div class="client-logo-container">
                                </div>
                                <button id="v24SchedulerCloseButton" class="close-scheduler" data-dismiss="modal" aria-label="Close">
                                    <svg viewBox="0 -6 21 32" width="2em" height="100%" role="img" aria-label="close"><path d="M18.015 19.957 10.058 12l7.957-7.958-1.058-1.057L9 10.942 1.042 2.985-.015 4.042 7.942 12l-7.957 7.957 1.057 1.058L9 13.058l7.958 7.957z" fill="currentColor"></path></svg>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div class="loader-container"><div class="loader"></div></div>
                                <div class="panel panel-default">
                                    <main class="panel-body">
                                        <vee24-scheduler-appointment-selection-section class="section hide" data-step="1" tabIndex="-1"></vee24-scheduler-appointment-selection-section>
                                        <vee24-scheduler-appointment-location-section data-step="2" class="section hide" tabIndex="-1"></vee24-scheduler-appointment-location-section>
                                        <vee24-scheduler-appointment-time-section data-step="3" class="section hide" tabIndex="-1"></vee24-scheduler-appointment-time-section>
                                        <vee24-scheduler-appointment-registration-section data-step="4" class="section hide" tabIndex="-1"></vee24-scheduler-appointment-registration-section>
                                        <vee24-scheduler-appointment-confirmation-section data-step="5" class="section hide" tabIndex="-1"></vee24-scheduler-appointment-confirmation-section>
                                    

                                        <vee24-scheduler-navigation class="v24-scheduler-button-row v24-show-flex" id="v24SchedulerButtonRow"></vee24-scheduler-navigation>
                                    </main>
                                </div>
                            </div>
                            <div id="v24-scheduler-modal-footer" class="v24-scheduler-modal-footer"></div>
                        </section>
                    </div>
                </div>`;
        }else {
            contentDiv.innerHTML = "";
        }
    }

    async load() {
        await this.#loadCSS();
        await this.#loadScripts();
    }

    #loadCSS() {
        let cssLoadQueue = [];
        cssLoadQueue.push(includeCSSFilePromise(buildUri(v24Scheduler.staticDomain, '/v24/veedesk/self-scheduler/self-scheduler.css'), 'v24css_master_scheduler', document.head));
        cssLoadQueue.push(includeCSSFilePromise(buildUri(v24Scheduler.staticDomain, '/v24/veedesk/self-scheduler/self-scheduler.css'), 'v24css_master_scheduler', this.container));
        cssLoadQueue.push(includeCSSFilePromise(buildUri(v24Scheduler.staticDomain, '/v24/veedesk/self-scheduler/intl-tel-input/dist/css/intlTelInput.css'), 'v24css_intlTelInput', this.container));

        return Promise.all(cssLoadQueue);
    }

    async loadCustomStyles({customFontPath}) {

        
        if (!customFontPath || customFontPath.length === 0) {
            return;
        }

        try {

                //this is being loaded in both light and shadow dom since animations and fonts need to be added to the main document
                await includeCSSFilePromise(customFontPath, 'v24css-fonts', document.head);
                await includeCSSFilePromise(customFontPath, 'v24css-fonts', this.container);
                await document.fonts.ready;

                return true;

        } catch (error) {
            console.error('Unable to load custom styles', error);
        }
    }

    #loadScripts() {

        const calendarScript = document.createElement('script');
        calendarScript.src = buildUri(v24Scheduler.staticDomain, '/v24/veedesk/self-scheduler/vee24-inline-date-picker/dist/vanillaCalendar.min.js');
        this.container.appendChild(calendarScript);

        //Load International Tel Input Javascript Library
        const intlTelInputScript = document.createElement('script');
        intlTelInputScript.src = buildUri(v24Scheduler.staticDomain, '/v24/veedesk/self-scheduler/intl-tel-input/dist/js/intlTelInput.min.js');
        this.container.appendChild(intlTelInputScript);

        return Promise.resolve();
    }

    querySelector(selector) {
        return this.container.querySelector(selector);
    }

    querySelectorAll(selector) {
        return this.container.querySelectorAll(selector);
    }

    appendChild(child) {
        this.container.appendChild(child);
    }

    remove() {
        this.parentElement.removeChild(this);
    }

    setContent(contentHtml) {
        if (this.#content) {
            this.#content.innerHTML = contentHtml;
        }
    }

    addBreadcrumb() {
        if (!this.querySelector('vee24-scheduler-breadcrumb')) {
            this.#content.insertAdjacentHTML("afterBegin", "<vee24-scheduler-breadcrumb></vee24-scheduler-breadcrumb>");
        }
    }

    #propagateRtlDirection() {
        const htmlDir = document.documentElement.getAttribute('dir');
        if (htmlDir) {
            const contentDiv = this.container.querySelector('#v24SchedulerContent');
            if (contentDiv) {
                contentDiv.setAttribute('dir', htmlDir);
            }
        }
    }
    
    #observeHtmlDirAttribute() {
        try {
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'dir') {
                        this.#propagateRtlDirection();
                    }
                });
            });
            
            observer.observe(document.documentElement, { attributes: true, attributeFilter: ['dir'] });
        } catch (error) {
            console.error('Error setting up dir attribute observer:', error);
        }
    }
}

